<template>
  <div>
    <Modal id="leave-group" :title="title" ref="modal">
      <div class="modal-body text-center">
        <slot name="default">
          <p class="text-justify">
            Are you sure you want to leave {{ getGroupName(getCurrentGroup) }}?
            <br />
            <br />
            {{ privateHiddenText }}
          </p>
        </slot>
      </div>
      <!-- Yes and No Buttons -->
      <div class="text-center">
        <slot name="footer">
          <SButton
            v-if="yesButtonName"
            :text="yesButtonName"
            color="blue"
            size="md"
            class="m-2"
            :disabled="yesButtonDisabled"
            @button="tryToLeaveGroup()"
            data-cy="tryToLeaveGroupBtn"
          />
          <SButton
            v-if="noButtonName"
            :text="noButtonName"
            color="primary"
            size="md"
            class="m-2"
            :disabled="noButtonDisabled"
            @button="closeModal()"
          />
        </slot>
      </div>
    </Modal>
  </div>
</template>
<script>
import SButton from "@/components/atoms/SButton";
import Modal from "@/components/atoms/Modal.vue";
import { mapGetters } from "vuex";
import GroupHelperVue from "../../mixins/GroupHelper.vue";
import ChatHelperVue from "../../mixins/ChatHelper.vue";
import UserHelperVue from "../../mixins/UserHelper.vue";
import groupPrivacy from "@/enum/group-privacy";
export default {
  name: "ModalLeaveGroup",
  mixins: [GroupHelperVue, ChatHelperVue, UserHelperVue],
  components: {
    SButton,
    Modal,
  },
  props: [
    "id",
    "yesButtonName",
    "noButtonName",
    "yesButtonDisabled",
    "noButtonDisabled",
  ],
  data() {
    return {
      title: "Leave Group",
      requesting: false,
    };
  },
  methods: {
    async tryToLeaveGroup() {
      if (this.isUserAuthenticated) {
        this.requesting = true;
        const result = await this.leaveGroup(this.getCurrentGroup.id);
        this.requesting = false;
        if (result.result === "You left this group successfully!") {
          let msg = `You have left the group ${this.getGroupName(
            this.getCurrentGroup
          )} successfully!`;
          this.sendSystemNotification({
            partnerId: this.loggedUser.id,
            msg: msg,
            type: "LEAVE_GROUP",
          });
          this.closeModal();
          this.$route.path !== "/s-app/feed" &&
            this.$router.push("/s-app/feed");
        }
      }
    },
    closeModal() {
      this.$refs.modal.closeModal();
    },
  },
  computed: {
    ...mapGetters(["isUserAuthenticated"]),
    privateHiddenText() {
      if (this.getCurrentGroup.privacy !== groupPrivacy.PUBLIC) {
        return `You will need the moderator's
            approval again if you want to rejoin the group in the future.`;
      }
      return "";
    },
  },
};
</script>
<style scoped>
.text-justify {
  text-align-last: center;
}
</style>
